import React, { Component } from 'react'
import { Button, TextField } from '@material-ui/core'
import {makeStyles} from '@material-ui/core/styles'
const styles = makeStyles({
    root: {
      margin: '10px'
    },
    div: {
        marginLeft: '50px'
    },
    mymessage: {
        background: "red"
    },
    othermessage: {
        background: 'yellow'
    }
  })
const Messages = (props) => {
    const classes = styles()
    const rows = props.messages.map((message, array_key) => {
        
        if (message.sender===props.username){
        return (
            <div><label className={classes.mymessage} key={array_key}>{message.sender}: {message.body}</label><br /></div>
        )}
        else {
           return(
            <div><label className={classes.othermessage} key={array_key}>{message.sender}: {message.body}</label><br /></div>
           )
        }
    })
    return (
        <div>

                {rows}

        </div>
    )
}
const Textinput = (props) => {
    const { inp_message } = props.app_state;
    const classes = styles();
    return (
        <div><p className={classes.root}>Codice stanza: {props.room_code}    <Button className={classes.root} variant="contained" color="primary" onClick={props.leaveroom}>Esci</Button></p>

            <TextField className={classes.root} type="text" variant="outlined" value={inp_message} onChange={props.onChange1} name="inp_message" color="primary"/><br />
            <Button className={classes.root} variant="contained" color="primary"  onClick={props.addMessage}>Manda</Button>
        </div>
    )
}
const Chat = (props) => {
    const classes = styles();
        const { onChange1, addMessage, messages, room_code, leaveroom, username } = props;
        return (<div className={classes.div}>
            <Textinput
                app_state={props.state}
                onChange1={onChange1}

                addMessage={addMessage}

                room_code={room_code}
                leaveroom={leaveroom}
            />
            <Messages
                messages={messages}
                username={username}
            />
        </div>)
    
}

export default Chat;